import React from 'react';
import Icon from '@bonprix/pattern-library/templates/icon';

export default function ErrorLayer({open = true, onClose = null, children = {}}) {
    if (open) {
        return (
            <div className="error-layer__table">
                <div className="error-layer__table-cell">
                    <div className="error-layer">
                        <div className="error-layer__inner">
                            <div className="error-layer__closer" onClick={onClose}>
                                <label>
                                    <Icon className="error-layer__closer-icon" name="closer" />
                                </label>
                            </div>
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    return null;
}
